import getConsideration from './Consideration';
import getContribution from './Contribution';
import getCredit from './Credit';
import getCureRemedies from './CureRemedies';
import getDisputeResolution from './DisputeResolution';
import getGoverningLaw from './GoverningLaw';
import getIndemnification from './Indemnification';
import getNameLikeness from './NameLikeness';
import getServices from './Services';
import getOwnership from './Ownership';
import getPayments from './Payments';
import getCreditNameLikeness from './CreditNameLikeness';

export default (blockName, blockOptions, options) => {
  switch (blockName) {
    case 'Contribution':
      return getContribution(blockOptions);

    case 'Credit':
      return getCredit(blockOptions);

    case 'Licensing Permissions':
      return '';

    case 'Governing Law':
      return getGoverningLaw(blockOptions);

    case 'Name & Likeness':
      return getNameLikeness(blockOptions);

    case 'Indemnification':
      return getIndemnification(blockOptions);

    case 'Dispute Resolution':
      return getDisputeResolution(blockOptions, options.state.field1);

    case 'Cure; Remedies':
      return getCureRemedies(blockOptions, options.type);

    case 'Consideration':
      return getConsideration(blockOptions);

    case 'Services':
      return getServices(blockOptions);

    case 'Ownership':
      return getOwnership(blockOptions, options.state);

    case 'Payments':
      return getPayments(blockOptions, options.type);

    case 'Credit; Name and Likeness':
      return getCreditNameLikeness(blockOptions);

    default:
      return '';
  }
};



// WEBPACK FOOTER //
// src/components/ContractBlock/Contents/index.js